import { render, staticRenderFns } from "./RecordPaymentModal.vue?vue&type=template&id=b37aed7e&"
import script from "./RecordPaymentModal.vue?vue&type=script&lang=js&"
export * from "./RecordPaymentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports